<ion-list>
  <ion-list-header lines="inset">
    <ion-grid class="msg-item">
      <ion-row>
        <ion-col size="1" class="flex-vertical-center">Typ</ion-col>
        <ion-col size="2" class="flex-vertical-center">Adresát</ion-col>
        <ion-col size="7">Text</ion-col>
        <ion-col size="2" class="msg-time flex-vertical-center">Čas</ion-col>
      </ion-row>
    </ion-grid>
  </ion-list-header>

  <ion-content>
    @for (msg of messages | sortBy: 'createdAt' : true; track msg; let i = $index) {
      <ion-item (click)="openMessage(msg)">
        <ion-grid class="msg-item">
          <ion-row>
            <ion-col size="1" class="flex-vertical-center">
              <span class="msg-type">Email</span>
            </ion-col>
            <ion-col size="2" class="flex-vertical-center">
              <span class="msg-from">{{ msg.recipient?.fullName() || 'Adresát nenalezen' }}</span>
            </ion-col>
            <ion-col size="7" class="msg-content">
              <ng-template [nestedEllipsis]>
                <span [innerHTML]="msg.content | bypassHtmlSanitizer"></span>
              </ng-template>
            </ion-col>
            <ion-col size="2" class="msg-time flex-vertical-center">
              {{ msg.createdAt | date: 'dd.MM.yyyy HH:mm' }}
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    }

    <ion-infinite-scroll #infiniteScroll threshold="100px" (ionInfinite)="loadMoreData()">
      <ion-infinite-scroll-content
        loadingSpinner="bubbles"
        loadingText="Načítám další zprávy..."
      ></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </ion-content>
</ion-list>
